import { createAction } from '@reduxjs/toolkit';
import {
  ActiveProjectSearchDTO,
  KontentContentTypeDTO,
  KontentDeliveryTaxonomyDTO,
  KontentProductDTO,
  KontentWorkflowStepDTO,
  TranslateRequestDTO,
} from 'utils/restApplicationClient';
import { ContentActionTypes } from './content.actions.types';
import { IContentPagination, IGetContentSucces } from './content.interface';

export const getContent = createAction<IContentPagination>(ContentActionTypes.GetContent);

export const getContentSuccess = createAction<IGetContentSucces>(ContentActionTypes.GetContentSuccess);

export const getContentError = createAction(ContentActionTypes.GetContentError);

export const setPagination = createAction<IContentPagination>(ContentActionTypes.SetPagination);

export const toggleEntry = createAction<KontentProductDTO>(ContentActionTypes.ToggleEntry);

export const toggleAllEntries = createAction(ContentActionTypes.ToggleAllEntries);

export const setSelectedEntries = createAction<KontentProductDTO[]>(ContentActionTypes.SetSelectedEntries);

export const addToQueue = createAction<TranslateRequestDTO>(ContentActionTypes.AddToQueue);

export const addToQueueSuccess = createAction<ActiveProjectSearchDTO>(ContentActionTypes.AddToQueueSuccess);

export const addToQueueError = createAction(ContentActionTypes.AddToQueueError);

export const sendForTranslation = createAction<TranslateRequestDTO>(ContentActionTypes.SendForTranslation);

export const sendForTranslationSuccess = createAction<ActiveProjectSearchDTO>(
  ContentActionTypes.SendForTranslationSuccess,
);
export const sendForTranslationError = createAction(ContentActionTypes.SendForTranslationError);

export const getContentTypes = createAction(ContentActionTypes.GetContentTypes);

export const getContentTypesSuccess = createAction<KontentContentTypeDTO[]>(ContentActionTypes.GetContentTypesSuccess);

export const getContentTypesError = createAction(ContentActionTypes.GetContentTypesError);

export const getWorkflowSteps = createAction(ContentActionTypes.GetWorkflowSteps);

export const getWorkflowStepsSuccess = createAction<KontentWorkflowStepDTO[]>(
  ContentActionTypes.GetWorkflowStepsSuccess,
);

export const getWorkflowStepsError = createAction(ContentActionTypes.GetWorkflowStepsError);

export const clearSelectedEntries = createAction(ContentActionTypes.ClearSelectedEntries);

export const getTaxonomy = createAction(ContentActionTypes.GetTaxonomy);

export const getTaxonomySuccess = createAction<Array<KontentDeliveryTaxonomyDTO>>(
  ContentActionTypes.GetTaxonomySuccess,
);

export const getTaxonomyError = createAction(ContentActionTypes.GetTaxonomyError);
